<template>
  <div class="web-pages-hero-editing web-pages-editing-block">
    <div class="web-pages-universal-fields">
      <div class="form-input">
        <label>Order of list</label>
        <input
          type="number"
          placeholder="1, 2, 3, 4 or 5"
          :value="selectedBlock.position"
          @input="
            $store.dispatch('webPages/handleBlockInput', {
              key: 'position',
              type: 'number',
              value: $event.target.value,
            })
          "
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "WebPagesUpsellBlockForm",
  data() {
    return {};
  },

  computed: {
    ...mapGetters("webPages", ["selectedBlock"]),
    ...mapGetters("languages", ["enabledLanguages"]),
  },
  mounted() {},
  methods: {},
};
</script>
